<div class="rings-loader">
    <div></div>
    <div></div>
    <div></div>
</div>
<div class="loading-message"> <ng-content></ng-content> </div>